// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"368":"fe16b167","875":"be3923da","928":"b947f758","985":"a4a58d1e"}[chunkId] + ".css";
};